module.exports = __webpack_public_path__ + "img/ic_hub_connect_line_left.53cc763c.svg";